// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".red[data-v-582d4bfb]{background-color:red}.custom-btn[data-v-582d4bfb]{border-color:var(--background)!important;color:#a3a3a3!important}.custom-btn-active[data-v-582d4bfb],.custom-btn[data-v-582d4bfb]:hover{background-color:var(--background)!important;border-color:var(--background)!important;color:var(--primary)!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
